<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Service from '../../services/movement-instruction';

export default{
  components: {Dialog, Button, DataTable, Column},
  props: ['item', 'idMovementInstructionHeader', 'reloadMovementInstruction'],
   data(){
    return {
        selectedVersion: null,
        versions: [],
        expandedRows: [],
        visible: false
    }
   },
   methods: {
    show(){
        this.visible = true;
    },
    loadData(){
        this.version = null;
        
        let params = {
            q: JSON.stringify({
                "recordData.Id": parseInt(this.idMovementInstructionHeader)
            }),
            sort: JSON.stringify({
                "recordData.Version": -1
            }),
            fields: JSON.stringify({
                "_id": 1,
                "recordData.Version": 1,
                "recordData.Code": 1,
                "recordData.Vessel": 1,
                "recordData.Inspector": 1,
                "recordData.Plant": 1,
                "recordData.LaycanEndDate": 1,
                "recordData.LaycanStartDate": 1,

                "recordData.MovementInstructionLots.Company": 1,
                "recordData.MovementInstructionLots.Counterparty": 1,
                "recordData.MovementInstructionLots.IncotermCode": 1,
                "recordData.MovementInstructionLots.OriginCountry": 1,
                "recordData.MovementInstructionLots.PlaceOfLoading": 1,
                "recordData.MovementInstructionLots.PortOrLocationOfLoading": 1,
                "recordData.MovementInstructionLots.DestinationCountry": 1,
                "recordData.MovementInstructionLots.PlaceOfDischarge": 1,
                "recordData.MovementInstructionLots.PortOrLocationOfDischarge": 1,
                "recordData.MovementInstructionLots.Product": 1,
                "recordData.MovementInstructionLots.Quantity": 1,
                "recordData.MovementInstructionLots.MaximumQuantity": 1,
                "recordData.MovementInstructionLots.MinimumQuantity": 1
            })
        };

        Service.previousVersion(params, response => {
            if(response.success){
                this.versions = response.data.data;
            }
        })
    },
    exportPdf(item){
        let params = {
            movementInstructionCode: item.recordData.Code
        };
        this.$store.dispatch("generic/setLoading", true);
        Service.printMovementInstruction(params, response => {
            
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                fileLink.setAttribute('download', item.recordData.Code + '.pdf');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    }
   },
}

</script>

<template>
    <main> 
        <Dialog :header="$t('movementInstructions.selectVersion')" v-model:visible="visible" :modal="true" :style="{width: '75vw'}">
            <DataTable :reorderableColumns="true" :value="versions" v-model:expandedRows="expandedRows" dataKey="_id" showGridlines stripedRows v-model:selection="selectedVersion">
                <Column :expander="true" headerStyle="width: 3rem" :reorderableColumn="false"/>
                <Column :exportable="false" :reorderableColumn="false">
                    <template #body="slotProps">
                        <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-outlined" @click="exportPdf(slotProps.data)" />
                    </template>
                </Column>
                <Column field="recordData.Code" :header="$t('code')" sortable></Column>
                <Column field="recordData.Vessel" :header="$t('movementInstructions.voyageNumber')" sortable></Column>
                <Column field="recordData.Inspector" :header="$t('inspector.fk')" sortable></Column>
                <Column field="recordData.Plant" :header="$t('registryPlant.fk')" sortable></Column>
                <Column field="recordData.LaycanStartDate" :header="$t('movementInstructions.laycanFrom')" sortable></Column>
                <Column field="recordData.LaycanEndDate" :header="$t('movementInstructions.laycanTo')" sortable></Column>
                <template #expansion="slotProps">
                    <h4>{{$t('movementInstructions.lots')}}</h4>
                    <DataTable :value="slotProps.data.recordData.MovementInstructionLots" :reorderableColumns="true">
                        <Column field="Company" :header="$t('company.fk')" sortable></Column>
                        <Column field="Counterparty" :header="$t('counterparty')" sortable></Column>
                        <Column field="IncotermCode" :header="$t('incoterm.fk')" sortable></Column>

                        <Column field="OriginCountry" header="OriginCountry" sortable></Column>
                        <Column field="PlaceOfLoading" header="PlaceOfLoading" sortable></Column>
                        <Column field="PortOrLocationOfLoading" header="PortOrLocationOfLoading" sortable></Column>

                        <Column field="DestinationCountry" header="DestinationCountry" sortable></Column>
                        <Column field="PlaceOfDischarge" header="PlaceOfDischarge" sortable></Column>
                        <Column field="PortOrLocationOfDischarge" header="PortOrLocationOfDischarge" sortable></Column>

                        <Column field="Product" :header="$t('product.fk')" sortable></Column>
                        <Column field="Quantity" :header="$t('movementInstructions.quantity')" sortable></Column>
                        <Column field="MinimumQuantity" :header="$t('movementInstructions.minimumQuantity')" sortable></Column>
                        <Column field="MaximumQuantity" :header="$t('movementInstructions.maximumQuantity')" sortable></Column>

                    </DataTable>
                </template>
            </DataTable>
        </Dialog>
    </main>
</template>